import { z } from 'zod'
import { optionalText, requiredText } from '../../../lib/forms/rules'

/**
 * Toplantı karar tipi ekle/düzenle form şeması (032): nameTr zorunlu; nameEn opsiyonel. Sıra (SORT_INDEX)
 * formda yok — sıralama tablodaki ↑/↓ oklarından yapılır (oluşturmada sona otomatik atanır).
 */
export const meetingDecisionTypeFormSchema = z.object({
  nameTr: requiredText(),
  nameEn: optionalText(),
})

export type MeetingDecisionTypeFormValues = z.infer<typeof meetingDecisionTypeFormSchema>
